import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateVehicle($companyId: ID!, $attributes: VehicleAttributes!) {
    createVehicle(companyId: $companyId, attributes: $attributes) {
       vehicle {
        id
        ...CreatedVehicle
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedVehicle on Vehicle {
    id
    name
    registration
    warehouse {
      id
      name
    }
    rateCents
    mileageCents
    model
    manufacturer
    cabSize
    width
    height
    length
    payload
    notes
  }
`
